import { render, staticRenderFns } from "./otherOwner.vue?vue&type=template&id=332c0c9c&scoped=true&"
import script from "./otherOwner.vue?vue&type=script&lang=js&"
export * from "./otherOwner.vue?vue&type=script&lang=js&"
import style0 from "./otherOwner.vue?vue&type=style&index=0&id=332c0c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c0c9c",
  null
  
)

component.options.__file = "otherOwner.vue"
export default component.exports